export const cleanManufacturerUrl = value => {
  value = value == null ? '' : String(value);
  const queryIndex = value.indexOf('?');
  const hashIndex = value.indexOf('#');
  if (queryIndex < 0 || (hashIndex >= 0 && hashIndex < queryIndex)) return value;
  return value.slice(0, queryIndex) + (hashIndex >= 0 ? value.slice(hashIndex) : '');
};
